const AssociatedEntityTypes = {
  INBOUNDDB_OBJECT: 'INBOUNDDB_OBJECT',
  SLACK_USER: 'SLACK_USER',
  SLACK_CHANNEL: 'SLACK_CHANNEL',
  NOTIFICATION_EMAIL_RECIPIENT: 'NOTIFICATION_EMAIL_RECIPIENT',
  NOTIFICATION_USER_RECIPIENT: 'NOTIFICATION_USER_RECIPIENT'
};
export default AssociatedEntityTypes;